import RichText from '~/src/common/components/CMS/RichText';
import { ReadMore } from '~/src/common/components/ReadMore/ReadMore';

import * as S from './layout';

interface Props {
  footer?: string;
}

const HomeScreenFooter = ({ footer }: Props) => {
  if (!footer) return null;

  return (
    <S.FooterContentContainer>
      <ReadMore>
        <RichText html={footer} />
      </ReadMore>
    </S.FooterContentContainer>
  );
};

export default HomeScreenFooter;
